export const API_URL =
  import.meta.env.VITE_API_URL || "https://api.memopal.app/api";

//se mantiene para pruebas locales
// export const API_URL =
//   import.meta.env.VITE_API_URL || "http://localhost:3000/api";
